import { render, staticRenderFns } from "./JoinMemberManagement.vue?vue&type=template&id=2df518d2"
import script from "./JoinMemberManagement.vue?vue&type=script&lang=js"
export * from "./JoinMemberManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports